import { lazy } from 'react';

// ----------------------------------------------------------------------

const PayrollAndAllowancesPage = lazy(() => import('../pages/PayrollAndAllowances.page'));

// ----------------------------------------------------------------------

const DeductionsRoutes = [
    {
        path: '/finances/deductions',
        element: <PayrollAndAllowancesPage />,
        layout: 'default',
        isAuthReq: true,
    },

];

export { DeductionsRoutes };
